module.exports = __webpack_public_path__ + "static/fonts/FiraSans-MediumItalic.5ac62a5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-MediumItalic.ttf
// module id = 1161
// module chunks = 5